import selectors from '../../../../rootSelectors';
import { goToQuestion, goToInterstitial } from '../../../../common/navigation/navigationActions';
import {
    blockScreen,
    unblockScreen,
    deactivateNextButton,
} from '../../../../common/screen/screenActions';
import { narrateStart, narrateReset } from '../../../../common/audio/audioActions';
import { setPlaylistItemCompleted } from '../../../../common/playlist/playlistActions';
import { resetQuestionsAndTimeTrackingState } from '../../../../common/questions/questionsActions';
import { saveMeasureResponse } from '../../../../common/api/vocabActions';
import VocaboServiceClient from '../../../../common/clients/VocaboServiceClient';
import { QUESTIONS } from '../../../../constants/assessmentItemType';
import { VOCAB } from '../../../../constants/measure';
import { autoplayScript } from '../../vocabBDActions';
import { startQuestionTimeTracking } from '../../../../common/timeTracking/timeTrackingActions';

export const narrateQuestionsScreen = (questionIndex, stimulusAudio) => async dispatch => {
    dispatch(blockScreen());
    dispatch(narrateStart());
    await dispatch(autoplayScript(questionIndex, stimulusAudio, QUESTIONS));
    dispatch(narrateReset());
    dispatch(unblockScreen());
    dispatch(startQuestionTimeTracking());
};

export const saveBDResponse = (response, questionIndex, isLastQuestion) => (dispatch, getStore) => {
    const state = getStore();
    const { itemId } = selectors.getVocabBDContent(state, QUESTIONS, questionIndex);
    const formId = selectors.getVocabBDFormId(state);
    const language = selectors.getCurrentLanguage(state);
    const responseId = selectors.getVocabBDSelectedResponseId(
        state,
        QUESTIONS,
        questionIndex,
        response,
    );

    return dispatch(
        saveMeasureResponse(
            VocaboServiceClient.MEASURES.BD,
            itemId,
            questionIndex,
            formId,
            language,
            responseId,
            isLastQuestion,
        ),
    );
};

export const onNextQuestionButtonClick = (response, questionIndex) => (dispatch, getState) => {
    const state = getState();
    const language = selectors.getCurrentLanguage(state);
    const isLastQuestion = questionIndex === selectors.getVocabBDTotalQuestions(state);

    dispatch(blockScreen());

    return dispatch(saveBDResponse(response, questionIndex - 1, isLastQuestion)).then(() => {
        const nextQuestion = questionIndex + 1;

        if (isLastQuestion) {
            dispatch(setPlaylistItemCompleted(VOCAB.BD, language));

            return dispatch(goToInterstitial());
        }

        dispatch(unblockScreen());
        dispatch(deactivateNextButton());
        dispatch(resetQuestionsAndTimeTrackingState());

        return dispatch(goToQuestion(VOCAB.ASSESSMENT, VOCAB.BD, nextQuestion));
    });
};
